<template>
  <div class="ac-card-content">
    <div class="edit-header-container">
      <button
        class="ac-close-button"
        @click="toggleModal(false)"
      >
        <img
          src="@shared/assets/img/general/x-black.png"
          alt="x"
          class="ac-close"
        >
      </button>
      <div
        v-if="isEdit"
        class="edit-header"
      >
        Edit and confirm filter details
      </div>
      <div
        v-else
        class="edit-header"
      >
        Filter Details
      </div>
    </div>
    <div class="ac-body-container">
      <div class="grid-row margin-bottom-4">
        <div class="sac__font-16 med midnight">
          Address
        </div>
        <SACDropdown
          placeholder="Select Option"
          :options="serviceAddressOptions"
          :value="filter.serviceAddressId"
          optionLabel="address1"
          optionValue="id"
          field="serviceAddressId"
          :change="changeFilterDetail"
          :error="errObj.addressErr"
        />
      </div>
      <div class="grid-row margin-bottom-4">
        <div class="sac__font-16 med midnight">
          Is the filter in the wall, ceiling, or furnace/ air handler?*
        </div>
        <SACDropdown
          placeholder="Select Option"
          :options="ventOptions"
          field="ventLocation"
          :value="filter.ventLocation"
          :change="changeFilterDetail"
          :error="errObj.ventLocationErr"
        />
      </div>
      <div class="grid-row margin-bottom-4">
        <div class="sac__font-16 med midnight">
          In what room is the filter located?
        </div>
        <SACInput
          placeholder="Enter Location"
          field="location"
          :value="filter.location"
          :change="changeFilterDetail"
          :error="errObj.locationErr"
        />
      </div>
      <div class="ac-body-sub-container">
        <div class="ac-input-container">
          <div class="grid-column">
            <div class="sac__font-16 med midnight">
              Filter Type*
            </div>
          </div>
          <SACDropdown
            placeholder="Select Brand"
            :options="filteredFilterBrands"
            field="brand"
            :value="filter.brand"
            :change="changeFilterDetail"
            :error="errObj.brandErr"
          />
        </div>
        <div class="ac-input-container">
          <div class="grid-column">
            <div class="sac__font-16 med midnight">
              Quality
            </div>
          </div>
          <SACDropdown
            placeholder="Select quality"
            :options="filterOptions"
            :value="filter.merv"
            field="merv"
            :change="changeFilterDetail"
            :error="errObj.mervErr"
          />
        </div>
      </div>
      <div v-if="filter.brand">
        <div v-if="!loadingCommonFilters">
          <div class="grid-column jc-s gap-20 margin-bottom-4">
            <div class="sac__font-16 bold midnight">
              Air Filter Size/ Model
            </div>
            <div class="tooltip-container">
              <img
                alt="Ruler"
                src="@shared/assets/img/air-filters/ruler.svg"
                class="tooltip-img"
              >
              <div class="tooltip-text">
                Select filter size printed on the side of your filter
              </div>
            </div>
          </div>
          <div v-if="filter.brand !== 'AprilAire'">
            <div
              v-if="showSbsFilter"
              class="ac-input-container"
            >
              <div class="sac__font-16 med midnight">
                How many air filter does this vent have?
              </div>
              <div class="grid-column ai-c jc-s gap-24">
                <SACRadio
                  name="one-filter"
                  field="sbsFilter"
                  :value="false"
                  :checked="filter?.sbsFilter === false"
                  :change="changeFilterDetail"
                  label="1 Filter"
                />
                <SACRadio
                  name="two-filter"
                  field="sbsFilter"
                  :value="true"
                  :checked="filter?.sbsFilter === true"
                  :change="changeFilterDetail"
                  label="2 Filter"
                />
              </div>
            </div>
            <div class="fs-container">
              <div
                v-if="!filter.ventLocation?.toLowerCase().includes('furnace')"
                class="sac__font-16 semi-bold"
              >
                Filter 1
              </div>
              <div class="ac-row-container margin-top-4">
                <div class="ac-input-container">
                  <div class="ac-input-header">
                    Filter Thickness
                  </div>
                  <SACDropdown
                    placeholder="Select Option"
                    :options="thicknessList"
                    :value="filter.thickness"
                    field="thickness"
                    :change="changeFilterDetail"
                    :error="errObj.thicknessErr"
                  />
                </div>
                <div class="ac-input-container">
                  <div class="ac-input-header">
                    Filter Size
                  </div>
                  <SACDropdown
                    placeholder="Select Option"
                    :options="filterSizeList"
                    :value="filter.catalogId"
                    optionValue="catalogId"
                    field="catalogId"
                    :change="changeFilterDetail"
                    :error="errObj.sizeErr"
                  />
                </div>
              </div>
              <div
                v-if="filter.catalogId === 'Not Listed'"
                class="custom-size-container margin-top-4"
              >
                <div class="sac__font-16 semi-bold">
                  Custom Size*
                </div>
                <div class="ac-row-container margin-top-4">
                  <div class="ac-input-container">
                    <div class="ac-input-header">
                      Width
                    </div>
                    <SACInput
                      placeholder="Enter Width"
                      field="width"
                      :value="filter.width"
                      :change="changeFilterDetail"
                      :error="errObj.widthErr"
                      type="number"
                    />
                  </div>
                  <div class="ac-input-container">
                    <div class="ac-input-header">
                      Height
                    </div>
                    <SACInput
                      placeholder="Enter Height"
                      field="height"
                      :value="filter.height"
                      :change="changeFilterDetail"
                      :error="errObj.heightErr"
                      type="number"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="filter.sbsFilter"
              class="fs-container margin-top-4"
            >
              <div class="sac__font-16 semi-bold">
                Filter 2
              </div>
              <div class="ac-input-container margin-top-4">
                <div class="ac-input-header">
                  Filter Size
                </div>
                <SACDropdown
                  placeholder="Select size"
                  :options="sbsFilterSizeList"
                  :value="filter.sbsCatalogId"
                  optionValue="catalogId"
                  field="sbsCatalogId"
                  :change="changeFilterDetail"
                  :error="errObj.sbsSizeErr"
                />
              </div>
              <div
                v-if="filter.sbsCatalogId === 'Not Listed'"
                class="custom-size-container margin-top-4"
              >
                <div class="sac__font-16 semi-bold">
                  Custom Size*
                </div>
                <div class="ac-row-container margin-top-4">
                  <div class="ac-input-container">
                    <div class="ac-input-header">
                      Width
                    </div>
                    <SACInput
                      placeholder="Enter Width"
                      field="sbsWidth"
                      :value="filter.sbsWidth"
                      :change="changeFilterDetail"
                      :error="errObj.sbsWidthErr"
                      type="number"
                    />
                  </div>
                  <div class="ac-input-container">
                    <div class="ac-input-header">
                      Height
                    </div>
                    <SACInput
                      placeholder="Enter Height"
                      field="sbsHeight"
                      :value="filter.sbsHeight"
                      :change="changeFilterDetail"
                      :error="errObj.sbsHeightErr"
                      type="number"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <div class="ac-input-container">
              <div class="sac__font-16 med midnight">
                Model Number
              </div>
              <SACDropdown
                placeholder="Select option"
                :options="filterSizeList"
                :value="filter.catalogId"
                optionValue="catalogId"
                field="catalogId"
                :change="changeFilterDetail"
                :error="errObj.sizeErr"
              />
            </div>
            <div
              v-if="filter.catalogId === 'Not Listed'"
              class="ac-input-container"
            >
              <div class="sac__font-14 midnight">
                Custom Size
              </div>
              <div class="grid-column gap-10">
                <SACInput
                  v-model="filter.thickness"
                  placeholder="Enter Thickness"
                  type="number"
                  field="thickness"
                  :error="errObj.thicknessErr"
                />
                <SACInput
                  v-model="filter.width"
                  placeholder="Enter Width"
                  type="number"
                  field="width"
                  :error="errObj.widthErr"
                />
                <SACInput
                  v-model="filter.height"
                  placeholder="Enter Height"
                  type="number"
                  field="height"
                  :error="errObj.heightErr"
                />
              </div>
            </div>
          </div>
        </div>
        <div
          v-else
          class="loading-container margin-bottom-4"
        >
          <img
            alt="Loading"
            src="@shared/assets/img/general/loading.svg"
          >
        </div>
      </div>
    </div>
    <div :class="[isEdit && !selectedFilter.monitored ? 'ac-delete-container' : 'ac-footer-container']">
      <div
        v-if="isEdit && !selectedFilter.monitored"
        class="sac__font-16 med punch underline btn"
        @click="toggleActionModal(true, 'delete-filter', filter)"
      >
        Delete Filter
      </div>
      <button
        class="ac-form-button"
        @click="handleAction"
      >
        Save
      </button>
    </div>
    <ProcessOverlay
      :show="processing"
      text="Saving Filter Details"
      overlayClass="ac-overlay"
    />
  </div>
</template>

<script>
import _ from 'lodash';
import customerDetailMixin from '@shared/mixins/customerDetailMixin';
import SACRadio from '@shared/components/sac/SACRadio.vue';
import ProcessOverlay from '@shared/components/ProcessOverlay.vue';
import SACInput from '../../sac/SACInput.vue';
import SACDropdown from '../../sac/SACDropdown.vue';
import validateFilter from '../../../lib/util/validateFilter';

export default {
  name: 'FilterForm',
  components: {
    ProcessOverlay,
    SACInput,
    SACDropdown,
    SACRadio,
  },
  mixins: [customerDetailMixin],
  props: {
    toggleModal: Function,
    isEdit: Boolean,
  },
  data() {
    return {
      filter: {},
      processing: false,
      errObj: {},
      loadingCommonFilters: false,
    };
  },
  computed: {
    serviceAddressOptions() {
      const serviceAddressOptions = this.customer.serviceAddress.map((add) => {
        const {
          address1,
          address2,
          city,
          state,
          zip,
        } = add;
        let fullAddress = `${address1} ${city}, ${state} ${zip}`;
        if (address2) {
          fullAddress = `${address1} ${address2} ${city}, ${state} ${zip}`;
        }
        const newAddress = {
          ...add,
          fullAddress,
        };
        return newAddress;
      });
      return serviceAddressOptions;
    },
    showSbsFilter() {
      return !this.filter.ventLocation?.toLowerCase().includes('furnace');
    },
    filteredFilterBrands() {
      const {
        ventLocation,
      } = this.filter;
      if (!ventLocation) {
        return [];
      }
      if (!this.showSbsFilter) {
        return this.filterBrands.filter((item) => item.label !== 'Zephyr');
      }
      let filter = this.filterBrands;
      const isWallOrCeiling = ventLocation?.toLowerCase().includes('wall') || ventLocation?.toLowerCase().includes('ceiling');
      if (isWallOrCeiling) {
        filter = this.filterBrands.filter((item) => item.label !== 'Honeywell');
      }

      return filter.filter((item) => item.label !== 'AprilAire');
    },
    sbsFilterSizeList() {
      const {
        thickness,
        height,
        width,
      } = this.filter;
      const filterList = [];
      this.commonFilters.forEach((cf) => {
        if (thickness === cf.thickness && (height === cf.height || width === cf.width)) {
          const label = `${cf.width} x ${cf.height}`;
          filterList.push({ ...cf, label });
        }
      });
      filterList.push({
        catalogId: 'Not Listed',
        label: 'Not Listed',
      });
      return filterList;
    },
    filterSizeList() {
      const {
        thickness,
        brand,
      } = this.filter;
      const filterList = [];
      this.commonFilters.forEach((cf) => {
        if (brand !== 'AprilAire') {
          if (Number(thickness) === cf.thickness) {
            const label = `${cf.width} x ${cf.height}`;
            filterList.push({ ...cf, label });
          }
        } else {
          const label = `${cf.model} (${cf.width} x ${cf.height} x ${cf.thickness})`;
          filterList.push({ ...cf, label });
        }
      });
      filterList.push({
        catalogId: 'Not Listed',
        label: 'Not Listed',
      });
      return filterList;
    },
  },
  watch: {
    'filter.brand': function (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.searchFilterCatalog();
      }
    },
  },
  mounted() {
    if (this.isEdit) {
      this.filter = _.cloneDeep(this.selectedFilter);
      this.filter = {
        ...this.filter,
        catalogId: this.selectedFilter.catalogId ? this.selectedFilter.catalogId : 'Not Listed',
        sbsCatalogId: this.selectedFilter.sbsCatalogId ? this.selectedFilter.sbsCatalogId : this.selectedFilter.sbsHeight ? 'Not Listed' : null,
        sbsFilter: !!this.selectedFilter.sbsHeight,
      };
    }
    this.$store.dispatch('getFilterBrands');
    this.searchFilterCatalog();
  },
  methods: {
    changeFilterDetail(field, value) {
      let updated = { ...this.filter };
      if ((field === 'catalogId' || field === 'sbsCatalogId') && value === 'Not Listed') {
        updated = {
          ...updated,
          [field === 'catalogId' ? 'height' : 'sbsHeight']: updated.height,
          [field === 'catalogId' ? 'width' : 'sbsWidth']: updated.width,
          [field === 'catalogId' ? 'thickness' : 'sbsThickness']: updated.thickness,
          [field]: value,
        };
      } else if (field === 'catalogId' || field === 'sbsCatalogId') {
        const sizeFound = this.commonFilters.find((cf) => cf.catalogId === Number(value));
        if (sizeFound) {
          updated = {
            ...updated,
            [field === 'catalogId' ? 'height' : 'sbsHeight']: sizeFound.height,
            [field === 'catalogId' ? 'width' : 'sbsWidth']: sizeFound.width,
            [field === 'catalogId' ? 'thickness' : 'sbsThickness']: sizeFound.thickness,
            [field]: value,
          };
        }
      } else if (field === 'thickness' && this.filter.thickness !== value) {
        updated = {
          ...updated, [field]: value, catalogId: null, sbsCatalogId: null, sbsThickness: value,
        };
      } else if (field === 'brand' && updated.brand !== value) {
        updated = {
          ...updated,
          [field]: value,
          catalogId: null,
          sbsCatalogId: null,
          height: null,
          width: null,
          thickness: null,
          sbsHeight: null,
          sbsWidth: null,
          sbsThickness: null,
          sbsFilter: false,
          merv: null,
        };
      } else if (field === 'sbsFilter' && value === false) {
        updated = {
          ...updated,
          [field]: value,
          sbsCatalogId: null,
          sbsHeight: null,
          sbsWidth: null,
          sbsThickness: null,
        };
      } else if (field === 'ventLocation' && value.toLowerCase().includes('furnace')) {
        updated = {
          ...updated,
          [field]: value,
          catalogId: null,
          sbsFilter: false,
          sbsCatalogId: null,
          sbsHeight: null,
          sbsWidth: null,
          sbsThickness: null,
          merv: null,
          brand: null,
        };
      } else if (field === 'ventLocation' && !value.toLowerCase().includes('furnace')) {
        updated = {
          ...updated,
          [field]: value,
          catalogId: null,
          sbsFilter: false,
          sbsCatalogId: null,
          sbsHeight: null,
          sbsWidth: null,
          sbsThickness: null,
          merv: null,
          brand: null,
        };
      } else {
        updated = { ...updated, [field]: value };
      }
      this.filter = _.cloneDeep(updated);
    },
    async searchFilterCatalog() {
      if (this.filter.brand) {
        try {
          this.loadingCommonFilters = true;
          await this.$store.dispatch('getCommonFiltersByBrand', {
            filter: this.filter,
          });
        } catch (err) {
          this.$store.dispatch('showAlertToast', {
            message: 'Failed to get filter catalogs. Please try again or contact support',
          });
        }
        this.loadingCommonFilters = false;
      }
    },
    async handleAction() {
      this.errObj = validateFilter(this.filter);
      if (Object.keys(this.errObj).length === 0) {
        try {
          this.processing = true;
          if (this.isEdit) {
            await this.$store.dispatch('updateCustomerFilter', {
              filter: this.filter,
            });
            await this.$store.dispatch('showSuccessToast', {
              header: 'Filter update was successful.',
              message: `${this.filter.location} filter was updated`,
            });
          } else {
            await this.$store.dispatch('createCustomerFilter', {
              filter: this.filter,
            });
            await this.$store.dispatch('showSuccessToast', {
              header: 'Filter was added successful.',
              message: `${this.filter.location} filter was added`,
            });
          }
          await this.toggleModal(false);
          if (!this.isEdit) {
            await this.$store.dispatch(
              'setDetailCustomer',
              {
                customerId: this.customer.id,
                activeTab: this.activeTab,
                actionType: 'add-new-filter',
              },
            );
          }
        } catch (err) {
          console.error(err);
          await this.$store.dispatch('showAlertToast', {
            message: 'There was an unexpected error updating the filter. Please try again or contact support',
          });
        }
        this.processing = false;
      }
    },
  },
};
</script>
<style lang="scss">

.date-container {
  display: flex;
  align-items: center;
  font-size: 14px;
  height: 44px;
  width: 100%;
}

.error-message {
  color: $TOMATO100;
  font-size: 0.875rem;
  font-weight: 500;
  padding-left: 4px;
  margin-top: 5px;
}

.edit-header-container {
  padding: 29px 24px 19px 24px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 20px;
  border-bottom: 1px solid #EDF2FF;

  .edit-header {
    font-size: 1.25rem;
    font-weight: 500;
  }
}

.fs-container {
  border: 1px solid $N10;
  padding: 16px;
  border-radius: 8px;
}

.custom-size-container {
  padding: 8px;
  border-radius: 8px;
}
</style>
